<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  data() {
    return {
      chart_options: {
        scales: {
          yAxes: [{}],
        },
        responsive: true,
        maintainAspectRatio: this.maintainAspectRatio,
        title: {
          display: true,
          text: this.title_text,
        },
        legend: {
          display: true,
          position: "bottom",
        },
      },

      datas: {},
    };
  },
  mounted() {
    // Overwriting base render method with actual data.
  },
  methods: {
    drawLineGraph(datas_line) {
      this.renderChart(datas_line, this.chart_options);
    },
  },
  props: {
    maintainAspectRatio: {
      default: true,
    },
    title_text: {
      type: String,
      required: false,
      default: "TITOLO",
    },
  },
};
</script>
